import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import WithTornBackground from 'ui/layouts/WithTornBackground';
import { childrenType } from 'utils/types';

import s from './BeigeHeader.module.scss';

const cx = cn.bind(s);

const BeigeHeader = ({
  children, className, hasCircles = true, hasTorn = false, ...attrs
}) => {
  const rootClassName = cx('header', className, { hasCircles });
  const RootComponent = hasTorn ? WithTornBackground : 'div';
  const rootProps = (() => (hasTorn ? { prepend: <div className={cx('bg')}></div> } : {}))();
  return <RootComponent {...rootProps} className={rootClassName} {...attrs}>
    {children}
  </RootComponent>;
};

BeigeHeader.propTypes = {
  children: childrenType,
  className: PropTypes.string,
  hasCircles: PropTypes.bool,
};

export default BeigeHeader;
